<template>
    <div>
        <v-dialog
            v-model="display"
            scrollable
            persistent
            :width="loading.data ? 500 : 1150">
            <v-card>
                <v-card-title>{{ $t('EXT_WORKSHOPS_TITLE') }}</v-card-title>
                 <div class="text-center">
                    <v-progress-circular
                        indeterminate
                        v-if="loading.data"
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-card-text  v-if="!loading.data">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{ $t('EXT_WORKSHOP_NAME') }}</th>
                                <td>{{ externalWorkshop.name }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('EXT_WORKSHOP_PHONE') }}</th>
                                <td>{{ externalWorkshop.phone }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-subheader v-if="externalWorkshopMaintenances.length">{{ $t('JOBCARD_EXT_MAINT_DESC') }}</v-subheader>
                    <v-simple-table v-if="externalWorkshopMaintenances.length" dense>
                        <thead>
                            <tr>
                                <th>{{ $t('data') }}</th>
                                <th>{{ $t('JOBCARDS_CODE') }}</th>
                                <th>{{ $t('TRUCK_TYPE') }}</th>
                                <th>{{ $t('TRUCK_PLATE') }}</th>
                                <th>{{ $t('ITEM_DESCRIPTION') }}</th>
                                <th>{{ $t('JOBCARD_EXT_MAINT_QTY') }}</th>
                                <th>{{ $t('JOBCARD_EXT_MAINT_PRICE') }}</th>
                                <th>{{ $t('JOBCARD_PAGE_TABLE_TOTAL') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(externalWorkshopMaintenance, index) in externalWorkshopMaintenances" :key="index">
                                <td>{{ externalWorkshopMaintenance.jobcard.date_enter }}</td>
                                <td>{{ externalWorkshopMaintenance.jobcard.code }}</td>
                                <td>{{ externalWorkshopMaintenance.truck.truck_type }}</td>
                                <td>{{ externalWorkshopMaintenance.truck.plate_number }}</td>
                                <td>{{ externalWorkshopMaintenance.description }}</td>
                                <td>{{ externalWorkshopMaintenance.quantity }}</td>
                                <td>{{ externalWorkshopMaintenance.price }}</td>
                                <td>{{ externalWorkshopMaintenance.total }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="close">{{ $t('BTN_CLOSE') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/RetryDialog';
import { mapActions, mapState } from 'vuex';
export default {
    name: "ExternalWorkshopDisplayDialog",
    components: {
        RetryDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            loading: {
                data: true
            }
            
        }
    },
    computed: {
        ...mapState("externalWorkshop", ["externalWorkshop", "externalWorkshopMaintenances"])
    },
    methods: {
        ...mapActions("externalWorkshop", ["fetchExternalWorkshop", "fetchExternalWorkshopMaintenances"]),
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.display = true;
            this.openDataFetch();
        },
        async openDataFetch() {
            try {
                await Promise.all([this.fetchExternalWorkshop(this.openParams.id), this.fetchExternalWorkshopMaintenances(this.openParams.id) ]);
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        close() {
            this.display = false;
        },
        onRetryDialogSubmit(params) {
            if(params.target == "openDataFetch") {
                if(params.retry == true) this.openDataFetch();
            }
        }
    }
}
</script>